import init from "./common";
import { Tabs } from "./utils/tabs";
import LazyLoad from "vanilla-lazyload";

jQuery(function () {
  init();

  // Init Lazy load instance
  var lazyLoad = new LazyLoad();

  var tabs_container = document.getElementById("tabs");
  if (tabs_container !== null) {
    const tabs = new Tabs({
      elem: "tabs",
      open: 0,
    });
  }
});
